/* Troca de produtos sem recarregar a pagina (pedido do cliente 2026-10-15).
   Pilulas de tipo, "View all" das fileiras e paginacao buscam SO a section da
   grade pela Section Rendering API (?section_id=...), trocam o #ProductGridContainer
   e atualizam a URL. Pre-carrega ao encostar na pilula e guarda em memoria, entao
   voltar pra uma aba ja vista e instantaneo. Carrossel e imagens adiadas
   re-iniciam sozinhos (ui-carrossel.js e UiAdia observam o DOM). */
(function () {
  'use strict';
  var cache = {};
  var emCurso = null;
  var SEL = 'a[data-ui-pilula], .ui-fileira__ver, .ui-paginacao a[href]';

  function grade() { return document.getElementById('product-grid'); }
  function container() { return document.getElementById('ProductGridContainer'); }

  function urlSection(href) {
    var u = new URL(href, location.href);
    var g = grade();
    if (!g || !g.dataset.id) return null;
    u.searchParams.set('section_id', g.dataset.id);
    return u.toString();
  }

  function buscar(href) {
    var chave = urlSection(href);
    if (!chave) return Promise.reject(new Error('sem section'));
    if (cache[chave]) return cache[chave];
    cache[chave] = fetch(chave, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .catch(function (e) { delete cache[chave]; throw e; });
    return cache[chave];
  }

  function marcarPilulas(href) {
    var u = new URL(href, location.href);
    var estilo = u.searchParams.get('filter.p.m.custom.kit') || '';
    var outroFiltro = false;
    u.searchParams.forEach(function (v, k) {
      if (k.indexOf('filter.') === 0 && k !== 'filter.p.m.custom.kit' && v !== '') outroFiltro = true;
    });
    document.querySelectorAll('.ui-pilula').forEach(function (p) {
      var ativa = outroFiltro ? false : (p.dataset.uiPilula || '') === estilo;
      p.classList.toggle('ui-pilula--ativa', ativa);
      if (ativa) p.setAttribute('aria-current', 'true'); else p.removeAttribute('aria-current');
    });
  }

  function aplicar(html, href, rolar) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var novo = doc.getElementById('ProductGridContainer');
    var alvo = container();
    if (!novo || !alvo) { location.href = href; return; }
    alvo.innerHTML = novo.innerHTML;
    var contNovo = doc.getElementById('ProductCountDesktop');
    var cont = document.getElementById('ProductCountDesktop');
    if (contNovo && cont) {
      cont.innerHTML = contNovo.innerHTML;
      cont.dataset.productCount = contNovo.dataset.productCount || '';
    }
    marcarPilulas(href);
    alvo.classList.remove('ui-trocando');
    if (rolar) {
      var topo = (document.querySelector('.ui-pilulas') || alvo).getBoundingClientRect().top;
      if (topo < 0) window.scrollBy({ top: topo - 12, behavior: 'smooth' });
    }
  }

  function navegar(href, empurrar) {
    var alvo = container();
    if (!alvo) { location.href = href; return; }
    var pedido = { href: href };
    emCurso = pedido;
    alvo.classList.add('ui-trocando');
    marcarPilulas(href);
    buscar(href).then(function (html) {
      if (emCurso !== pedido) return;
      if (empurrar) history.pushState({ psFiltro: href }, '', href);
      aplicar(html, href, true);
    }).catch(function () { if (emCurso === pedido) location.href = href; });
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var el = e.target;
    if (!el || !el.closest) return;
    var a = el.closest(SEL);
    if (!a || !a.href || !grade()) return;
    var u = new URL(a.href, location.href);
    if (u.origin !== location.origin || u.pathname !== location.pathname) return;
    e.preventDefault();
    navegar(a.href, true);
  });

  /* pre-carrega ao encostar/tocar: quando o clique chega, o HTML ja esta aqui */
  function pre(e) {
    var el = e.target;
    if (!el || !el.closest) return;
    var a = el.closest('a[data-ui-pilula], .ui-fileira__ver');
    if (a && a.href && grade()) buscar(a.href).catch(function () {});
  }
  document.addEventListener('pointerenter', pre, true);
  document.addEventListener('touchstart', pre, { passive: true, capture: true });

  window.addEventListener('popstate', function (e) {
    if (!grade()) return;
    if (e.state && e.state.psFiltro) navegar(location.href, false);
    else if (history.state === null) navegar(location.href, false);
  });

  if (grade()) history.replaceState({ psFiltro: location.href }, '', location.href);
})();
